import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { callGrab } from "../redux/socketAction/socketAction";

function WaitingCalls(props) {
    const [callWaiting, setCallWaiting] = useState(props.waitingCalls)
    const config_api = JSON.parse(localStorage.getItem("config"));
    let session_state = useSelector((state) => state)
    const dispatch = useDispatch();

    useEffect(() => {
        setCallWaiting(props.waitingCalls);
      }, [props.waitingCalls]);

    const grabCall = (data) =>{
        let payload = {
            tenant_id: config_api.tenant_code,
            agent: config_api.projects[0].userInfo[0].user_email,
            station: config_api.projects[0].userInfo[0].user_phone_number,
            uniqueid: data.id,
            queue: data.qu,
            action: 'call-grab',
        }
        localStorage.setItem("grab-data",JSON.stringify(payload));
        dispatch(callGrab(session_state.background.websocketconnection, payload))
    }
    return (
        <div
        className="call-waitings">
            <h3 style={{ color: "#3b82f6", marginBottom: "10px" }}>Waiting Calls</h3>
            <hr />
            {callWaiting.map((item) => {
                return<div className="call-waiting-content" >
                    <div>
                        <p style={{ margin: "5px 0" }}>
                            <strong>Queue:</strong> {item.qu}
                        </p>
                        <p style={{ margin: "5px 0" }}>
                            <strong>Caller:</strong> {item.pn}
                        </p>
                        <p style={{ margin: "5px 0" }}>
                            <strong>Duration:</strong>{item.du}
                        </p>
                    </div>
               
                <div
                className="call-grab-icon">
                    <FontAwesomeIcon icon={faPhone} style={{ color: "green", fontSize: "24px" }} onClick={()=>grabCall(item)}/>
                </div>
            </div> })}
        </div>
    );
}

export default WaitingCalls;
